/* Verify (13-11). Built to design/mock-13 (Verify tab): .pagehead, .tsheet, .linked, .age,
   tr.rej, .bulkbar and dialog.confirm. Purple is identity only (headings, focus); the completion
   verb is teal; age past E4's window is a gentle amber, never red (D-13-02-1). */

.page {
  max-width: var(--shell-max);
  margin: 0 auto;
  padding: 0 var(--shell-gutter) 120px;
}

/* ---------- page head ---------- */
.head {
  padding: 50px 0 28px;
  display: flex;
  align-items: flex-end;
  gap: 24px;
  flex-wrap: wrap;
}

.title {
  font-family: var(--serif);
  font-weight: 400;
  font-size: 40px;
  line-height: 1.1;
  color: var(--purple-dark);
  letter-spacing: -0.01em;
}

.lede {
  margin-top: 8px;
  color: var(--gray);
  max-width: 66ch;
}

.side {
  margin-left: auto;
  font-size: 13.5px;
  color: var(--gray);
  text-align: right;
}

.side b {
  display: block;
  font-family: var(--serif);
  font-weight: 500;
  font-size: 30px;
  color: var(--charcoal);
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}

/* ---------- filters ---------- */
.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 14px;
  margin-bottom: 16px;
}

.filter {
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--gray);
}

.filter select {
  height: 38px;
  min-width: 140px;
  max-width: 220px;
  border: 1px solid var(--sage-dark);
  border-radius: 10px;
  background: var(--white)
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236B7280' stroke-width='2.5'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")
    no-repeat right 12px center;
  padding: 0 34px 0 12px;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  color: var(--charcoal);
  appearance: none;
  cursor: pointer;
}

.filter select:focus-visible {
  outline: none;
  border-color: var(--purple);
  box-shadow: 0 0 0 3px rgba(127, 63, 150, 0.1);
}

.showing {
  margin-left: auto;
  font-size: 13.5px;
  color: var(--gray);
  padding-bottom: 9px;
}

/* ---------- the table ---------- */
.tsheet {
  background: var(--white);
  border: 1px solid var(--line);
  border-radius: 18px;
  box-shadow: var(--shadow-sm);
  overflow-x: auto;
  overflow-y: hidden;
  /* The containing block for the visually hidden inputs / labels, so they scroll with the
     table instead of widening the page at phone width. */
  position: relative;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.table th {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--gray);
  text-align: left;
  padding: 12px 14px;
  border-bottom: 1px solid var(--sage-dark);
  background: var(--white);
  white-space: nowrap;
}

.table td {
  padding: 14px;
  border-bottom: 1px solid var(--line);
  vertical-align: top;
}

.table tbody tr:last-child td {
  border-bottom: none;
}

.row {
  transition: opacity 0.3s ease;
  outline: none;
}

.row[data-hovered] td {
  background: #fbfdfc;
}

.row[data-selected] td {
  background: var(--lavender-light);
}

.row[data-focus-visible] td {
  box-shadow: inset 0 2px 0 var(--purple), inset 0 -2px 0 var(--purple);
}

.row[data-focus-visible] td:first-child {
  box-shadow: inset 2px 2px 0 var(--purple), inset 0 -2px 0 var(--purple);
}

.row[data-focus-visible] td:last-child {
  box-shadow: inset -2px 2px 0 var(--purple), inset 0 -2px 0 var(--purple);
}

.leaving {
  opacity: 0;
}

.ck {
  width: 44px;
  padding-left: 18px !important;
  padding-right: 4px !important;
}

.colCard {
  width: 170px;
}

/* the row's question (13.1-14): what the verifier is being asked */
.question {
  font-weight: 600;
  color: var(--charcoal);
}

.colRecord {
  min-width: 300px;
}

.colWrote {
  width: 19%;
}

.colWhen {
  width: 104px;
}

.colAge {
  width: 72px;
}

.num {
  text-align: right !important;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.old {
  color: var(--amber);
  font-weight: 600;
}

.acts {
  white-space: nowrap;
  text-align: right !important;
}

.mono {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.when {
  white-space: nowrap;
}

.sub {
  font-size: 12.5px;
  color: var(--gray);
  margin-top: 3px;
}

.ref {
  color: var(--charcoal);
  text-decoration: underline;
  text-decoration-color: var(--sage-dark);
  text-underline-offset: 3px;
}

.ref:hover {
  color: var(--purple-dark);
  text-decoration-color: var(--purple-light);
}

.sr {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

/* the linked Action Register row */
.linked {
  margin-top: 8px;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  background: var(--sage-light);
  border-radius: 10px;
  padding: 8px 11px;
  font-size: 12.8px;
  max-width: 520px;
}

.linked b {
  font-weight: 600;
}

/* the linked action's details, short form */
.about {
  margin-top: 3px;
  line-height: 1.4;
  color: var(--charcoal);
}

.linkedQuiet {
  background: var(--bg);
}

.lk {
  flex: none;
  color: var(--teal-dark);
  font-weight: 700;
}

/* why a row can't be verified here: said, never hidden */
.refusal {
  margin-top: 8px;
  max-width: 520px;
  font-size: 12.8px;
  color: var(--amber);
  background: var(--amber-soft);
  border: 1px solid var(--amber-line);
  border-radius: 10px;
  padding: 7px 11px;
}

/* 13-13 (ISS-194): audit rows still owed after a verdict saved. Amber, never red: nothing is lost yet. */
.owed {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 16px;
  margin: 0 0 16px;
  padding: 10px 14px;
  font-size: 13.6px;
  color: var(--charcoal);
  background: var(--amber-soft);
  border: 1px solid var(--amber-line);
  border-radius: 12px;
}

.owed p {
  flex: 1 1 320px;
  margin: 0;
}

.owed b {
  color: var(--amber);
}

.rowNote {
  margin-top: 8px;
  max-width: 520px;
  font-size: 12.8px;
  color: var(--charcoal);
}

.tag {
  display: inline-block;
  font-size: 11.5px;
  font-weight: 600;
  padding: 2px 9px;
  border-radius: 999px;
  background: var(--sage-light);
  color: var(--gray);
  white-space: nowrap;
  vertical-align: middle;
}

.tagRejected {
  background: var(--amber-soft);
  color: var(--amber);
}

/* the quiet inline tick */
.tick {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  font-size: 13px;
  font-weight: 600;
  color: var(--teal-dark);
}

.tickIcon {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: var(--teal);
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.tickIcon path {
  stroke-dasharray: 16;
  stroke-dashoffset: 16;
  animation: draw 0.42s var(--ease) 0.06s forwards;
}

@keyframes draw {
  to {
    stroke-dashoffset: 0;
  }
}

.chev {
  width: 30px;
  height: 30px;
  margin-left: 4px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  color: var(--gray);
  background: none;
  border: none;
  cursor: pointer;
}

.chev svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2.2;
  transition: transform 0.2s var(--ease);
}

.chev[data-hovered] {
  background: var(--lavender-light);
  color: var(--purple-dark);
}

.chev[data-focus-visible] {
  outline: 2px solid var(--purple);
  outline-offset: 2px;
}

.chevOpen {
  transform: rotate(180deg);
}

/* checkboxes (RAC Checkbox, slot="selection") */
.check {
  display: inline-flex;
  cursor: pointer;
}

.check[data-disabled] {
  cursor: not-allowed;
}

.box {
  width: 17px;
  height: 17px;
  border-radius: 4px;
  border: 1.5px solid var(--gray-light);
  background: var(--white);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}

.box[data-on] {
  background: var(--teal);
  border-color: var(--teal);
}

.box[data-off] {
  opacity: 0.35;
}

.box svg {
  width: 12px;
  height: 12px;
  fill: none;
  stroke: #fff;
  stroke-width: 2.4;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.check[data-focus-visible] .box {
  outline: 2px solid var(--purple);
  outline-offset: 2px;
}

/* the expanded row: reject composer + details */
.detailRow td {
  background: var(--bg);
}

.detailRow:has(.reject) td {
  background: var(--amber-soft);
}

.reject {
  max-width: 760px;
}

.rejectLabel {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}

.field {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.input {
  flex: 1;
  min-width: 220px;
  height: 36px;
  border: 1px solid var(--sage-dark);
  border-radius: 10px;
  background: var(--white);
  padding: 0 12px;
  font: inherit;
  font-size: 14px;
  color: var(--charcoal);
}

.input:focus {
  outline: none;
  border-color: var(--purple);
  box-shadow: 0 0 0 3px rgba(127, 63, 150, 0.1);
}

.hint {
  font-size: 12.5px;
  color: var(--gray);
  margin-top: 6px;
}

.details {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 18px 32px;
  margin-top: 4px;
}

.reject + .details {
  margin-top: 18px;
}

.facts {
  display: grid;
  grid-template-columns: 130px minmax(0, 1fr);
  gap: 6px 14px;
  font-size: 13.5px;
  align-content: start;
}

.facts dt {
  color: var(--gray);
}

.facts dd {
  min-width: 0;
}

.hash {
  white-space: normal;
  word-break: break-all;
  font-size: 12.5px;
}

.evidence {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.trail a {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--teal-dark);
}

/* empty / notice */
.empty {
  padding: 64px 24px;
  text-align: center;
  color: var(--gray);
}

.empty h2,
.notice h2 {
  font-family: var(--serif);
  font-weight: 400;
  font-size: 28px;
  color: var(--purple-dark);
  margin-bottom: 6px;
}

.empty .btn {
  margin-top: 14px;
}

.notice {
  background: var(--white);
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 40px 32px;
  max-width: 640px;
  color: var(--gray);
}

/* ---------- Done today: verdicts given today, with "Correct this" (13-11.1, D-13-R-5) ---------- */
.doneToday {
  margin-top: 34px;
  max-width: 900px;
}

.doneToday h2 {
  font-family: var(--serif);
  font-weight: 500;
  font-size: 20px;
  color: var(--purple-dark);
  margin: 0 0 4px;
}

.doneLede {
  font-size: 13.5px;
  color: var(--gray);
  margin: 0 0 10px;
}

.doneList {
  list-style: none;
  margin: 0;
  padding: 0;
  background: var(--white);
  border: 1px solid var(--line);
  border-radius: 14px;
}

.doneItem {
  padding: 12px 16px;
  border-top: 1px solid var(--line);
  font-size: 13.5px;
}

.doneItem:first-child {
  border-top: none;
}

.doneMain {
  display: flex;
  align-items: center;
  gap: 10px 14px;
  flex-wrap: wrap;
}

.doneWhat {
  flex: 1 1 220px;
  min-width: 0;
  overflow-wrap: anywhere;
}

.correct {
  margin-top: 12px;
}

/* ---------- buttons (the mock's .btn) ---------- */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 18px;
  border-radius: 999px;
  font: inherit;
  font-size: 13.5px;
  font-weight: 600;
  border: 1px solid transparent;
  background: none;
  color: inherit;
  white-space: nowrap;
  cursor: pointer;
  vertical-align: middle;
  transition: background 0.2s, border-color 0.2s, color 0.2s, transform 0.12s;
}

.btn[data-pressed]:not([data-disabled]) {
  transform: scale(0.97);
}

.btn[data-focus-visible] {
  outline: 2px solid var(--purple);
  outline-offset: 2px;
}

.btn[data-disabled] {
  opacity: 0.38;
  cursor: not-allowed;
}

.go {
  background: var(--teal);
  color: #fff;
}

.go[data-hovered]:not([data-disabled]) {
  background: var(--teal-dark);
}

.line {
  background: var(--white);
  border-color: var(--sage-dark);
  color: var(--charcoal);
}

.line[data-hovered]:not([data-disabled]) {
  border-color: var(--purple-light);
  color: var(--purple-dark);
}

.quiet {
  color: var(--gray);
  padding: 0 12px;
}

.quiet[data-hovered]:not([data-disabled]) {
  background: var(--lavender-light);
  color: var(--purple-dark);
}

.sm {
  height: 30px;
  padding: 0 13px;
  font-size: 12.8px;
}

.acts .sm + .sm {
  margin-left: 4px;
}

/* ---------- bulk bar ---------- */
.bulkbar {
  position: sticky;
  bottom: 22px;
  z-index: 40;
  margin: 18px auto 0;
  width: max-content;
  max-width: 100%;
  display: flex;
  align-items: center;
  gap: 14px;
  background: var(--charcoal);
  color: #fff;
  border-radius: 999px;
  padding: 7px 8px 7px 22px;
  box-shadow: 0 12px 30px rgba(45, 45, 45, 0.25);
  font-size: 14px;
  animation: barIn 0.28s var(--ease);
}

@keyframes barIn {
  from {
    opacity: 0;
    transform: translateY(14px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

.aside {
  font-size: 12.5px;
  color: var(--gray-light);
}

.onDark {
  color: var(--gray-light);
}

.onDark[data-hovered]:not([data-disabled]) {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

/* ---------- confirm dialog (the mock's dialog.confirm) ---------- */
.overlay {
  position: fixed;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(45, 45, 45, 0.3);
  backdrop-filter: blur(2px);
  padding: 16px;
}

.overlay[data-entering] {
  animation: fade 0.2s ease;
}

.modal {
  width: min(480px, 100%);
  max-height: calc(100vh - 32px);
  overflow: auto;
  background: var(--white);
  border-radius: 20px;
  box-shadow: 0 30px 70px rgba(45, 45, 45, 0.25);
}

.modal[data-entering] {
  animation: popIn 0.26s var(--ease);
}

@keyframes fade {
  from {
    opacity: 0;
  }
}

@keyframes popIn {
  from {
    opacity: 0;
    transform: scale(0.97) translateY(6px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

.dialog {
  outline: none;
}

.cb {
  padding: 26px 28px 8px;
}

.cb h2 {
  font-family: var(--serif);
  font-weight: 400;
  font-size: 26px;
  line-height: 1.2;
  color: var(--purple-dark);
  margin-bottom: 10px;
}

.cb p {
  font-size: 14.5px;
  color: var(--charcoal);
  margin-bottom: 10px;
}

.cb .muted,
.muted {
  color: var(--gray);
  font-size: 13.5px;
}

.breakdown {
  list-style: none;
  margin: 4px 0 12px;
  font-size: 14px;
}

.breakdown li {
  padding: 6px 0;
  border-top: 1px solid var(--line);
}

.breakdown li:first-child {
  border-top: none;
}

.breakdown b {
  display: inline-block;
  min-width: 34px;
  font-family: var(--serif);
  font-weight: 500;
  font-size: 17px;
  font-variant-numeric: tabular-nums;
}

.cf {
  padding: 16px 28px 22px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.progress {
  height: 6px;
  border-radius: 999px;
  background: var(--sage-light);
  overflow: hidden;
  margin: 14px 0 12px;
}

.progress i {
  display: block;
  height: 100%;
  width: 40%;
  background: var(--teal);
  border-radius: 999px;
  animation: sweep 1.1s ease-in-out infinite alternate;
}

@keyframes sweep {
  from {
    transform: translateX(-10%);
  }
  to {
    transform: translateX(160%);
  }
}

.result {
  font-family: var(--serif);
  font-size: 21px !important;
  line-height: 1.35;
  color: var(--charcoal);
  margin: 4px 0 14px;
}

.exlist {
  list-style: none;
  font-size: 13.5px;
  margin-bottom: 8px;
}

.exlist li {
  padding: 7px 0;
  border-top: 1px solid var(--line);
}

.exlist li:first-child {
  border-top: none;
}

/* ---------- show the next page ---------- */
.more {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-top: 18px;
  font-size: 13.5px;
  color: var(--gray);
}

/* ---------- responsive (the mock's 1100 / 720 px steps) ---------- */
@media (max-width: 1100px) {
  .table td,
  .table th {
    padding-left: 10px;
    padding-right: 10px;
  }

  .colRecord {
    min-width: 230px;
  }

  .colCard {
    width: 120px;
  }
}

@media (max-width: 960px) {
  .details {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 720px) {
  .tsheet {
    overflow-x: auto;
  }

  .table {
    min-width: 860px;
  }

  .filters {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }

  .filter select {
    min-width: 0;
    max-width: none;
    width: 100%;
  }

  .showing {
    grid-column: 1 / -1;
    margin-left: 0;
    padding-bottom: 0;
  }

  .bulkbar .aside {
    display: none;
  }
}
